import type { IntakeFormData } from "./form";

export function uuid(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
  );
}

/**
 * Default values for every field on the intake form. The `formStore` seeds
 * its initial state from this, the `intakeApi` adapter uses it as the
 * baseline when mapping sparse backend responses, and `mockApi` builds its
 * seed data on top of it. Keeping one canonical shape prevents drift as
 * per-step stories add fields.
 */
export const EMPTY_FORM_DATA: IntakeFormData = {
  effectiveDate: "",
  companyLegalName: "",
  dba: "",
  federalTaxId: "",
  streetAddress: "",
  city: "",
  state: "",
  zipCode: "",
  orgType: "",
  sicCode: "",
  sicDescription: "",
  yearEstablished: "",
  avgW2Employees: null,
  avgW2Employees20Weeks: null,
  contactName: "",
  contactTitle: "",
  contactEmail: "",
  contactPhone: "",
  fiduciarySameAsContact: null,
  fiduciaryName: "",
  fiduciaryTitle: "",
  fiduciaryEmail: "",
  fiduciaryPhone: "",
  needAlternatePortalAccess: null,
  portalContactName: "",
  portalContactEmail: "",
  portalContactPhone: "",
  portalReplaces: "",
  owners: [{ id: uuid(), firstName: "", lastName: "", mi: "" }],
  hasCba: null,
  cbaUnitName: "",
  cbaEffectiveDate: "",
  hasPeo: null,
  peoType: "",
  isMultiEmployer: null,
  multiEmployerType: "",
  isCommonlyControlledGroup: null,
  affiliatedGroups: [],
  primaryEligibleEmployees: null,
  ownershipAssignments: [],
  replacingMedical: null,
  priorMedicalCarrier: "",
  priorMedicalCarrierOther: "",
  priorMedicalPlanType: "",
  priorMedicalEffectiveDate: "",
  replacingDental: null,
  deductibleYearType: "",
  medicalContribution: 50,
  offeringDental: null,
  offeringVision: null,
  reimburseCopays: null,
  offerHsa: null,
  offerHra: null,
  otherReimbursement: null,
  excludeClass: null,
  excludedClasses: [],
  excludedClassesOther: "",
  allowDomesticPartners: null,
  minHoursPerWeek: 30,
  waitingPeriod: "",
  waiveWaitingPeriod: null,
  employeesInWaitingPeriod: null,
  offerCOBRAVoluntary: null,
  employeesOnCOBRA: null,
  useOptimylCOBRA: null,
  wantOptimylSection125: null,
  section125PlanMedical: false,
  section125PlanDental: false,
  section125PlanVision: false,
  section125TierEmployeeOnly: false,
  section125TierEmployeeSpouse: false,
  section125TierEmployeeChildren: false,
  section125TierEmployeeFamily: false,
  paymentMethod: "ACH",
  achAccountHolderName: "",
  achBankName: "",
  achRoutingNumber: "",
  achAccountNumber: "",
  achAccountType: "Checking",
  totalEnrolledEmployees: null,
  docVerificationType: "",
  newlyFormedCompany: null,
  documents: { wageTax: null, payroll: null, newBusinessDocs: null, priorBill: null, voidedCheck: null, censusFile: null, binderCheck: null },
  ownerEligibilityDocs: [],
  employees: [],
};
